/* eslint-disable */
import {pegaDados, processar} from '../../services/GenericAPI'
import {DicionarioSefazSCH} from '../../search/DicionarioSefazSCH'
import {Filtro} from '../../models/filtro/filtro'
import {getBaseSCH} from '../../search/BaseSCH'

const url = '/dicionario_sefaz';

const state = {
  all: [],
  allList: [],
  filtro: new Filtro(),
  dicionario_sefaz: [],
  editando: false,
};

const getters = {
  pegaFiltro: (state) => {
    return state.filtro
  },
  pegaEditando: (state) => {
    return state.editando
  },
  listaDicionarioSefaz: (state) => {
    return state.all
  },
  pegarDicionarioSefaz: (state) => {
    return state.dicionario_sefaz
  },
};

const actions = {
  setEditando({commit}, edit) {
    commit('SET_EDITANDO', edit)
  },
 setDicionarioSefaz({commit}, dicionario_sefaz) {
    commit('SET_DICIONARIO_SEFAZ', dicionario_sefaz)
  },

  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.filterRaw = []
    state.filtro.filters.addSearch(['tp_documento','codigo_erro_sefaz', 'mensagem_erro_sefaz','titulo_traduzido','mensagem_traduzida'],
     '%'+search+'%',
     'ilike'
    )
  },
  async getDicionarioSefaz({commit}, {id,onSucesso,onErro}) {
    try {
      let filtro = getBaseSCH('dicionario_sefaz_id', id, '=');

      const list = (await pegaDados(url+'/getAdmin', filtro)).data;
      onSucesso( list.data[0])
    } catch (error) {
      console.log(error)
      onErro()
    }

  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', DicionarioSefazSCH(perPage))
  },

  async setAllDicionarioSefaz ({ commit },{onSucesso,onErro}) {
    try {
      const list = (await pegaDados(url+'/getAdmin', state.filtro)).data;

      commit('SET_DICIONARIO_SEFAZ_ALL', list);
      onSucesso()
    } catch (error) {
      onErro([])
    }
  },


  async processarDicionarioSefaz({commit}, {acao, onSucesso, onErro}) {
    try {
      let res = await processar(url + (acao==='gravar'?'/commit':'/delete'), state.dicionario_sefaz, acao)
      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      console.log('error: ', error)
      this.dispatch('geral/setObjMsgError', error.response.data)
      onErro()
    }
  },


};

const mutations = {
  SET_LOG(state, log) {
    state.logs_audit = log
  },
  SET_DICIONARIO_SEFAZ_ALL (state, dicionario_sefaz) {
    state.all = dicionario_sefaz
  },

  SET_DICIONARIO_SEFAZ (state, dicionario_sefaz) {
    state.dicionario_sefaz = dicionario_sefaz
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_EDITANDO(state, edit) {
    state.editando = edit
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
